var map = {
	"./alfa-romeo/alfa-romeo.png": 34503,
	"./audi/audi.png": 33099,
	"./bajaj/bajaj.png": 69463,
	"./bmw/bmw.png": 74135,
	"./brp/brp.png": 18319,
	"./byd/byd.png": 76691,
	"./car-label.png": 33357,
	"./chery/chery.png": 26467,
	"./chevrolet/captiva.png": 58993,
	"./chevrolet/chevrolet.png": 33955,
	"./chevrolet/cobalt.png": 97250,
	"./chevrolet/onix.png": 92243,
	"./chevrolet/prisma.png": 71023,
	"./chrysler/chrysler.png": 6725,
	"./citroen/citroen.png": 92127,
	"./daf/daf.png": 82339,
	"./dafra/dafra.png": 96915,
	"./dodge/dodge.png": 51251,
	"./ducati/ducati.png": 26441,
	"./effa/effa.png": 51261,
	"./exeed/exeed.png": 19291,
	"./ferrari/ferrari.png": 23091,
	"./fiat/fiat.png": 12089,
	"./ford/ecosport.png": 28003,
	"./ford/edge.png": 93763,
	"./ford/fiesta.png": 63422,
	"./ford/focus.png": 18414,
	"./ford/ford.png": 32755,
	"./ford/fusion.png": 89456,
	"./ford/ka +.png": 95455,
	"./ford/ka.png": 49204,
	"./ford/old/ecosport.png": 81421,
	"./ford/old/edge.png": 79733,
	"./ford/old/fiesta.png": 19444,
	"./ford/old/focus-sedan.png": 61474,
	"./ford/old/focus.png": 6064,
	"./ford/old/fusion.png": 4582,
	"./ford/old/ka +.png": 44261,
	"./ford/old/ka.png": 98014,
	"./ford/old/ka2.png": 95726,
	"./ford/old/ranger.png": 5701,
	"./ford/ranger.png": 81415,
	"./foton/foton.png": 43419,
	"./fym/fym.png": 76423,
	"./geely/geely.png": 81063,
	"./gwm/gwm.png": 87419,
	"./haojue/haojue.png": 42325,
	"./harley-davidson/harley-davidson.png": 56935,
	"./honda/accord.png": 96497,
	"./honda/civic.png": 28075,
	"./honda/honda.png": 31155,
	"./hyundai/hyundai.png": 83707,
	"./indian/indian.png": 22879,
	"./iveco/iveco.png": 12671,
	"./jac/jac.png": 98999,
	"./jaguar/jaguar.png": 85745,
	"./jeep/jeep.png": 25697,
	"./kawasaki/kawasaki.png": 34977,
	"./kia/kia.png": 46371,
	"./ktm/ktm.png": 48287,
	"./land-rover/land-rover.png": 33557,
	"./lexus/lexus.png": 53503,
	"./lifan/lifan.png": 79787,
	"./mahindra/mahindra.png": 28729,
	"./mercedes-benz/mercedes-benz.png": 35551,
	"./mini/mini.png": 67595,
	"./mitsubishi/mitsubishi.png": 86131,
	"./miura/miura.png": 67963,
	"./nissan/nissan.png": 12889,
	"./peugeot/peugeot.png": 34131,
	"./porsche/porsche.png": 45963,
	"./puma/puma.png": 81827,
	"./ram/ram.png": 18151,
	"./renault/renault.png": 93163,
	"./royal-enfield/royal-enfield.png": 69643,
	"./scania/scania.png": 30131,
	"./seres/seres.png": 90703,
	"./smart/smart.png": 55923,
	"./ssangyong/ssangyong.png": 66215,
	"./subaru/subaru.png": 33945,
	"./susuki/susuki.png": 10057,
	"./suzuki/suzuki.png": 85731,
	"./toyota/toyota.png": 63089,
	"./triumph/triumph.png": 26091,
	"./troller/troller.png": 37611,
	"./volkswagen/volkswagen.png": 9619,
	"./volvo/volvo.png": 27871,
	"./yamaha/yamaha.png": 64055,
	"./zeekr/zeekr.png": 38247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3543;